export const SITE_DEFAULTS = {
  alert: { enabled: true, text: "" },
  contact: {
    hours: "Po–Čt 11:00–22:00\nPá–So 11:00–23:00\nNe ZAVŘENO",
    phone: "+420 774 048 597",
    email: "indickaplzen@email.cz",
  },
  aboutText:
    "V restauraci Everest vám nabízíme autentickou chuť indické a nepálské kuchyně v srdci Plzně.\n" +
    "Naše jídla jsou připravována tradičními postupy z čerstvých surovin a s láskou k exotickým kořením.\n" +
    "Přijďte si užít útulnou atmosféru a přívětivou obsluhu.",
  stableMenu: { enabled: true, currentPdf: "" },
  dailyMenu: { enabled: true, hours: "11:00–14:30", groups: [] },
};

export function deepMergeSiteDefaults(d) {
  const src = d && typeof d === "object" ? d : {};
  const stableMenuSource =
    src.stableMenu && typeof src.stableMenu === "object"
      ? src.stableMenu
      : src.staticMenu && typeof src.staticMenu === "object"
        ? src.staticMenu
        : {};
  return {
    ...SITE_DEFAULTS,
    ...src,
    alert: { ...SITE_DEFAULTS.alert, ...(src.alert || {}) },
    contact: { ...SITE_DEFAULTS.contact, ...(src.contact || {}) },
    stableMenu: { ...SITE_DEFAULTS.stableMenu, ...stableMenuSource },
    dailyMenu: { ...SITE_DEFAULTS.dailyMenu, ...(src.dailyMenu || {}) },
  };
}
